const SESSION_KEY = 'selectedPlan'

const loadFromSession = () => {
  try {
    const raw = sessionStorage.getItem(SESSION_KEY)
    return raw ? JSON.parse(raw) : {}
  } catch {
    return {}
  }
}

const initialState = {
  infoPlan: loadFromSession(),
  userSub: {}
}

const Planes_Reducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_INFO_PLAN':
      try { sessionStorage.setItem(SESSION_KEY, JSON.stringify(action.infoPlan)) } catch {}
      return { ...state, infoPlan: action.infoPlan }
    case 'CLEAR_INFO_PLAN':
      sessionStorage.removeItem(SESSION_KEY)
      return { ...state, infoPlan: {} }
    default:
      return state
  }
}

export const getInfoPlan = (state) => state.plans.infoPlan

export default Planes_Reducer
